import React from "react";

import { BoxProps, Box } from "@material-ui/core";
import { CustomPagination, CustomPaginationProps } from "../CustomPagination";
import { CustomPaper } from "../CustomPaper";

type Props = {
  paginationProps?: CustomPaginationProps;
} & BoxProps;

export const CustomPaginatedTableContainer: React.FC<Props> = ({
  children,
  paginationProps,
  ...props
}) => (
  <CustomPaper {...props}>
    <Box overflow="auto">{children}</Box>
    {paginationProps ? (
      <CustomPagination px={2} py={3} {...paginationProps} />
    ) : null}
  </CustomPaper>
);
